exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2n_n8bTmjFURculwghaEVK ._2hP5jX9aAI9RXlCsfintE9{min-width:130px}.ID_FX8dTNV4pXeCfEhhvD{position:fixed;left:0;top:0;z-index:-1;width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"context-view": "_2n_n8bTmjFURculwghaEVK",
	"monaco-menu": "_2hP5jX9aAI9RXlCsfintE9",
	"context-view-block": "ID_FX8dTNV4pXeCfEhhvD"
};